const POST_DATE_FORMAT = 'dd/MM/yyyy';
const NORMAL_DATE_FORMAT = 'YYYY-MM-DD';
const DUE_DATE_FORMAT = 'DD/MM/YYYY';
const DEFAULT_AVATAR_IMG = `/images/avatar.jpg`;
const DEFAULT_RESULT_IMG = `/images/default.png`;
const DEFAULT_IMG = `/images/default-image.jpg`;
const BMI_LEVELS = [
    'underweight',
    'healthy',
    'overweight',
    'obese_level_1',
    'obese_level_2',
];
const BMR_LEVELS = ['low', 'normal', 'high'];
const CORAL_TOKEN_COOKE = 'coral_together_user_token';
const HEALTH_TOOL_TYPE = {
    DUE_DATE: 'DUE_DATE',
    BMI: 'BMI',
    BMR: 'BMR',
    OVULATION: 'OVULATION',
    IFRAME: 'IFRAME',
    PWG: 'PWG',
    THR: 'THR',
    BGC: 'BGC',
};
const LOCALE_HEALTH_TOOLS = {
    'id-ID': {
        'kalkulator-bmi': HEALTH_TOOL_TYPE.BMI,
        'kebutuhan-kalori': HEALTH_TOOL_TYPE.BMR,
        'kalkulator-hari-perkiraan-lahir': HEALTH_TOOL_TYPE.DUE_DATE,
        'kalkulator-masa-subur-2': HEALTH_TOOL_TYPE.OVULATION,
        'kalkulator-kenaikan-berat-badan-ibu-hamil': HEALTH_TOOL_TYPE.PWG,
        'kalkulator-detak-jantung-saat-olahraga': HEALTH_TOOL_TYPE.THR,
    },
    'ms-MY': {
        'kalkulator-bmi': HEALTH_TOOL_TYPE.BMI,
        'kalkulator-bmr': HEALTH_TOOL_TYPE.BMR,
        'kalkulator-tarikh-bersalin': HEALTH_TOOL_TYPE.DUE_DATE,
        'kalkulator-kesuburan': HEALTH_TOOL_TYPE.OVULATION,
        'kalkulator-tambah-berat-badan-hamil': HEALTH_TOOL_TYPE.PWG,
        'target-heart-rate-calculator': HEALTH_TOOL_TYPE.THR,
    },
    'vi-VN': {
        'cach-tinh-chi-so-bmi': HEALTH_TOOL_TYPE.BMI,
        'tinh-chi-so-bmr': HEALTH_TOOL_TYPE.BMR,
        'cong-cu-tinh-ngay-du-sinh': HEALTH_TOOL_TYPE.DUE_DATE,
        'tinh-ngay-rung-trung': HEALTH_TOOL_TYPE.OVULATION,
        'cong-cu-tinh-can-nang-khi-mang-thai': HEALTH_TOOL_TYPE.PWG,
        'cong-cu-do-nhip-tim': HEALTH_TOOL_TYPE.THR,
    },
    'zh-TW': {
        'bmi-calculator': HEALTH_TOOL_TYPE.BMI,
        'bmr-calculator': HEALTH_TOOL_TYPE.BMR,
        'due-date-calculator': HEALTH_TOOL_TYPE.DUE_DATE,
        'ovulation-calculator': HEALTH_TOOL_TYPE.OVULATION,
        'pregnancy-weight-gain-calculator': HEALTH_TOOL_TYPE.PWG,
        'target-heart-rate-calculator': HEALTH_TOOL_TYPE.THR,
    },
    'en-PH': {
        'bmi-calculator': HEALTH_TOOL_TYPE.BMI,
        'bmr-calculator': HEALTH_TOOL_TYPE.BMR,
        'due-date-calculator': HEALTH_TOOL_TYPE.DUE_DATE,
        'ovulation-calculator': HEALTH_TOOL_TYPE.OVULATION,
        'pregnancy-weight-gain-calculator': HEALTH_TOOL_TYPE.PWG,
        'target-heart-rate-calculator': HEALTH_TOOL_TYPE.THR,
    },
    'th-TH': {
        'เครื่องคำนวณหา-ค่าดัชนี': HEALTH_TOOL_TYPE.BMI,
        'เครื่องคำนวณอัตราการเผาผลาญพลังงาน-bmr': HEALTH_TOOL_TYPE.BMR,
        เครื่องมือคำนวณกำหนดคลอด: HEALTH_TOOL_TYPE.DUE_DATE,
        'เครื่องคำนวณการตกไข่-ovulation-calculat': HEALTH_TOOL_TYPE.OVULATION,
        เครื่องคำนวณน้ำหนักตัว: HEALTH_TOOL_TYPE.PWG,
        เครื่องวัดอัตราการเต้น: HEALTH_TOOL_TYPE.THR,
    },
    'hi-IN': {
        'bmi-calculator-en': HEALTH_TOOL_TYPE.BMI,
        'bmi-calculator': HEALTH_TOOL_TYPE.BMI,
        'bmr-calculator': HEALTH_TOOL_TYPE.BMR,
        'delivery-date-calculator': HEALTH_TOOL_TYPE.DUE_DATE,
        'ovulation-calculator': HEALTH_TOOL_TYPE.OVULATION,
        'pregnancy-weight-gain-calculator': HEALTH_TOOL_TYPE.PWG,
        'target-heart-rate-calculator': HEALTH_TOOL_TYPE.THR,
    },
    'km-KH': {
        'គណនា-bmi': HEALTH_TOOL_TYPE.BMI,
        'គណនា-bmr': HEALTH_TOOL_TYPE.BMR,
        គណនាថ្ងៃសម្រាលកូន: HEALTH_TOOL_TYPE.DUE_DATE,
        គណនាថ្ងៃមេជីវិតញីទុំធ្លាក់: HEALTH_TOOL_TYPE.OVULATION,
        គណនាទម្ងន់ស្ត្រីពពោះ: HEALTH_TOOL_TYPE.PWG,
        គណនារកចង្វាក់បេះដូងល្អ: HEALTH_TOOL_TYPE.THR,
    },
    'my-MM': {
        'bmi-calculator': HEALTH_TOOL_TYPE.BMI,
        'bmr-calculator': HEALTH_TOOL_TYPE.BMR,
        'due-date-calendar': HEALTH_TOOL_TYPE.DUE_DATE,
        'ovulation-calculator': HEALTH_TOOL_TYPE.OVULATION,
        'pregnaancy-weight-calculator': HEALTH_TOOL_TYPE.PWG,
        'target-heartrate': HEALTH_TOOL_TYPE.THR,
        'pregnancy-weight-calculator': HEALTH_TOOL_TYPE.PWG,
        'target-heart-rate': HEALTH_TOOL_TYPE.THR,
    },
};
const BEARER_TOKEN_COOKIE = 'hhg_user_token';
const TOGETHER_DISCLAIMER_COOKIE = 'hhg_together_disclaimer';
const BEARER_ADMIN_TOKEN_COOKIE = 'together_admin_token';
const Z_INDEX = {
    adBlock: 48,
    articleAdContainer: 47,
    headerContainerHome: 99,
    headerContainerPopup: 200,
    headerContainerPopupSUbLevel: 300,
    menuSearchInputPopup: 5,
    menuSearchInputDisplayIcon: 6,
    menuSearchPopup: 200,
};
const BmrActiveLevels = [
    {
        value: 'sedentary',
        icon: 'bmr-sedentary',
        //'/images/toolsBMRSedentary.svg',
        name: 'bmr.activeLevel.sedentary',
        description: 'bmr.activeLevel.sedentary.description',
    },
    {
        value: 'lightly-active',
        icon: 'bmr-light',
        // icon: '/images/toolsBMRLightlyActive.svg',
        name: 'bmr.activeLevel.lightlyActive',
        description: 'bmr.activeLevel.lightlyActive.description',
    },
    {
        value: 'moderately-active',
        icon: 'bmr-moderately',
        // icon: '/images/toolsBMRModeratelyActive.svg',
        name: 'bmr.activeLevel.moderatelyActive',
        description: 'bmr.activeLevel.moderatelyActive.description',
    },
    {
        value: 'intensely-active',
        icon: 'bmr-intensively',
        // icon: '/images/toolsBMRIntenselyActive.svg',
        name: 'bmr.activeLevel.intenselyActive',
        description: 'bmr.activeLevel.intenselyActive.description',
    },
    {
        value: 'extremely-active',
        icon: 'bmr-extremely',
        // icon: '/images/toolsBMRExtremelyActive.svg',
        name: 'bmr.activeLevel.extremelyActive',
        description: 'bmr.activeLevel.extremelyActive.description',
    },
];
const LEAD_CAMPAIGN_CODE = 'lmoct7xfr5sv4fv';
const LEAD_TOKEN_COOKIE = 'hhg-id';
const GA_TOKEN_COOKIE = '_ga';
const GOOGLE_CALENDAR_AUTH_CLIENT_ID = '1038242799566-esoq4ij201ve5qfp266nbca44scpo3c6.apps.googleusercontent.com';
const FIND_CARE_IFRAME_URL = 'https://www.appsheet.com/start/4ba34ebe-3cb6-4c16-8dd4-d074025a5bb6#appName=DependentDropdowns-2711103&group=%5B%5D&page=card&sort=%5B%5D&table=Menu&view=Menu';
const REPORT_REASON_MAP = {
    report_scam: {
        label: 'morePopover.report.scam',
        reportReasonText: 'morePopover.report.scam',
    },
    report_sex: {
        label: 'morePopover.report.sex',
        reportReasonText: 'morePopover.report.sex',
    },
    report_offensive: {
        label: 'morePopover.report.offensive',
        reportReasonText: 'morePopover.report.offensive',
    },
    report_violence: {
        label: 'morePopover.report.violence',
        reportReasonText: 'morePopover.report.violence',
    },
    report_prohibited: {
        label: 'morePopover.report.prohibited',
        reportReasonText: 'morePopover.report.prohibited',
    },
    report_spam: {
        label: 'morePopover.report.spam',
        reportReasonText: 'morePopover.report.spam',
    },
    report_falseNews: {
        label: 'morePopover.report.falseNews',
        reportReasonText: 'morePopover.report.falseNews',
    },
    report_other: {
        label: 'morePopover.report.other',
        reportReasonText: 'morePopover.report.other',
    },
};
const MB_SOCIAL_LINKS = {
    LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
    FACEBOOK: 'https://www.facebook.com/marry.baby.vn',
    INSTAGRAM: 'https://www.instagram.com/marrybaby.vn/',
    TWITTER: '',
    YOUTUBE: 'https://www.youtube.com/channel/UCeZybTkY1VzJ3N7LvPGdKbg',
    ZALO: 'http://zalo.me/806483414530291942',
};
const INTERNAL_ROLES = ['admin', 'moderator', 'local-admin'];
const EXTERNAL_ROLES = [
    'ambassador',
    'expert',
    'sponsor',
    'guide',
    'influencer',
];
const INTERNAL_PROFILE_ROLES = ['moderator', 'local-admin'];
const EXTERNAL_PROFILE_ROLES = ['expert', 'ambassador', 'sponsor'];
const RoleDataMap = {
    moderator: {
        text: 'Moderator',
        fid: 'cardAuthor.moderator',
        background: '#fe921d',
    },
    admin: {
        text: 'Admin',
        fid: 'cardAuthor.admin',
        background: '#2b62cd',
    },
    'local-admin': {
        text: 'Local admin',
        fid: 'cardAuthor.localAdmin',
        background: '#2b62cd',
    },
    expert: {
        text: 'Expert',
        fid: 'cardAuthor.expert',
        background: '#ff6f4d',
    },
    sponsor: {
        text: 'Sponsor',
        fid: 'cardAuthor.sponsor',
        background: '#00c7e6',
    },
    ambassador: {
        text: 'Ambassador',
        fid: 'cardAuthor.ambassador',
        background: '#00CB8A',
    },
};
const MAX_IMAGE_UPLOADS = 20;
const LOCALISED_SLUGS = {
    'en-PH': {
        ALL: 'all',
        HOSPITAL: 'hospital',
        SERVICE: 'service',
        DOCTOR: 'doctor',
        SEARCH: 'search',
        SPECIALTIES: 'specialties',
        CURRENT: 'current-location',
    },
    'vi-VN': {
        ALL: 'tat-ca',
        HOSPITAL: 'benh-vien',
        SERVICE: 'dich-vu',
        DOCTOR: 'bac-si',
        SEARCH: 'tim-kiem',
        SPECIALTIES: 'chuyen-khoa',
        CURRENT: 'vi-tri-hien-tai',
    },
    'id-ID': {
        ALL: 'semua',
        HOSPITAL: 'rumah-sakit',
        SERVICE: 'layanan',
        DOCTOR: 'dokter',
        SEARCH: 'cari',
        SPECIALTIES: 'spesialisasi',
        CURRENT: 'posisi-saya-saat-ini',
    },
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  POST_DATE_FORMAT: POST_DATE_FORMAT,
  NORMAL_DATE_FORMAT: NORMAL_DATE_FORMAT,
  DUE_DATE_FORMAT: DUE_DATE_FORMAT,
  DEFAULT_AVATAR_IMG: DEFAULT_AVATAR_IMG,
  DEFAULT_RESULT_IMG: DEFAULT_RESULT_IMG,
  DEFAULT_IMG: DEFAULT_IMG,
  BMI_LEVELS: BMI_LEVELS,
  BMR_LEVELS: BMR_LEVELS,
  CORAL_TOKEN_COOKE: CORAL_TOKEN_COOKE,
  HEALTH_TOOL_TYPE: HEALTH_TOOL_TYPE,
  LOCALE_HEALTH_TOOLS: LOCALE_HEALTH_TOOLS,
  BEARER_TOKEN_COOKIE: BEARER_TOKEN_COOKIE,
  TOGETHER_DISCLAIMER_COOKIE: TOGETHER_DISCLAIMER_COOKIE,
  BEARER_ADMIN_TOKEN_COOKIE: BEARER_ADMIN_TOKEN_COOKIE,
  Z_INDEX: Z_INDEX,
  BmrActiveLevels: BmrActiveLevels,
  LEAD_CAMPAIGN_CODE: LEAD_CAMPAIGN_CODE,
  LEAD_TOKEN_COOKIE: LEAD_TOKEN_COOKIE,
  GA_TOKEN_COOKIE: GA_TOKEN_COOKIE,
  GOOGLE_CALENDAR_AUTH_CLIENT_ID: GOOGLE_CALENDAR_AUTH_CLIENT_ID,
  FIND_CARE_IFRAME_URL: FIND_CARE_IFRAME_URL,
  REPORT_REASON_MAP: REPORT_REASON_MAP,
  MB_SOCIAL_LINKS: MB_SOCIAL_LINKS,
  INTERNAL_ROLES: INTERNAL_ROLES,
  EXTERNAL_ROLES: EXTERNAL_ROLES,
  INTERNAL_PROFILE_ROLES: INTERNAL_PROFILE_ROLES,
  EXTERNAL_PROFILE_ROLES: EXTERNAL_PROFILE_ROLES,
  RoleDataMap: RoleDataMap,
  MAX_IMAGE_UPLOADS: MAX_IMAGE_UPLOADS,
  LOCALISED_SLUGS: LOCALISED_SLUGS
});

export { BEARER_TOKEN_COOKIE as B, DEFAULT_IMG as D, HEALTH_TOOL_TYPE as H, LOCALISED_SLUGS as L, MAX_IMAGE_UPLOADS as M, REPORT_REASON_MAP as R, DEFAULT_AVATAR_IMG as a, BEARER_ADMIN_TOKEN_COOKIE as b, constants as c, LEAD_TOKEN_COOKIE as d };
